import { post, put, get } from './request';
import { getTokenHeader } from './helpers';

const urlPrefix = 'quote/desking';

/**
 * @param {String} baseUrl
 * @param {String} token
 * @param {String} quoteId
 * @param {Object} queryParams
 * @param {Object} body
 * @returns {Promise}
 */
const basePostRequest = (baseUrl, token, quoteId, queryParams, body, urlPart) => {
    const url = `${baseUrl}/${urlPrefix}/${urlPart}/${quoteId}`;

    return post(url, body, {
        headers: getTokenHeader(token),
        params: {...queryParams, module: 2}
    });
};

const aprRoll = (...args) => basePostRequest(...args, 'aprRoll');
const getTransactionItems = (...args) => basePostRequest(...args, 'transaction/items');
const paymentRoll = (...args) => basePostRequest(...args, 'paymentRoll');
const profitRoll = (...args) => basePostRequest(...args, 'profitRoll');
const updatePaymentOptions = (...args) => basePostRequest(...args, 'paymentOptions');
const updateTransactionDetails = (...args) => basePostRequest(...args, 'transaction');
const validateTaxableAmount = (...args) => basePostRequest(...args, 'transaction/taxableAmountValidation');
const validateTransactionAmount = (...args) => basePostRequest(...args, 'transaction/amountValidation');
const validateTransactionItem = (...args) => basePostRequest(...args, 'transaction/itemValidation');

/**
 * @param {String} baseUrl
 * @param {String} token
 * @param {String} quoteId
 * @param {Object} queryParams
 * @param {Object} body
 * @returns {Promise}
 */
const transactionPdfRequest = (baseUrl, token, quoteId, queryParams, body) => {
    const formId = '25bb3ed9-eaf3-46e0-9585-6ea5a4ea214b';
    const url = `${baseUrl}/${urlPrefix}/form/${quoteId}/${formId}`;

    return post(url, body, {
        headers: getTokenHeader(token),
        params: {...queryParams, module: 2},
        responseType: 'arraybuffer'
    });
};

/**
 * @param {String} baseUrl
 * @param {String} token
 * @param {String} quoteId
 * @param {Object} queryParams
 * @param {Object} body
 * @returns {Promise}
 */
const updateQuoteInformation = (baseUrl, token, quoteId, queryParams, body) => {
    const url = `${baseUrl}/${urlPrefix}/${quoteId}`;

    return put(url, body, {
        headers: getTokenHeader(token),
        params: {...queryParams, module: 2}
    });
};

const getQuoteInformation = (baseUrl, token, quoteId, queryParams) => {
    const url = `${baseUrl}/${urlPrefix}/${quoteId}`;

    return get(url, {
        headers: getTokenHeader(token),
        params: {...queryParams, module: 2}
    });
}

const getQuoteSummary = (baseUrl, token, quoteId, queryParams) => {
    const url = `${baseUrl}/quote/summary/${quoteId}`;

    return get(url, {
        headers: getTokenHeader(token),
        params: {...queryParams, module: 2}
    });
}


export default {
    aprRoll,
    getTransactionItems,
    paymentRoll,
    profitRoll,
    transactionPdfRequest,
    updatePaymentOptions,
    updateQuoteInformation,
    getQuoteInformation,
    getQuoteSummary,
    updateTransactionDetails,
    validateTaxableAmount,
    validateTransactionAmount,
    validateTransactionItem
};
